import { render, staticRenderFns } from "./QueryPuddingC.vue?vue&type=template&id=26407cbc&"
import script from "./QueryPuddingC.vue?vue&type=script&lang=js&"
export * from "./QueryPuddingC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports